import api from './api';

const ragService = {
  // Collections
  async getCollections() {
    const response = await api.get('/rag/collections');
    return response.data;
  },


  async getStats() {
    const response = await api.get('/rag/stats');
    return response.data;
  },

  async getCollection(collectionId) {
    const response = await api.get(`/rag/collections/${collectionId}`);
    return response.data;
  },

  async createCollection(data) {
    const response = await api.post('/rag/collections', data);
    return response.data;
  },

  async deleteCollection(collectionId) {
    const response = await api.delete(`/rag/collections/${collectionId}`);
    return response.data;
  },

  // Display-name-only rename (superadmin-gated). Does NOT touch internal_name
  // — vector store data is preserved. Backend updates the cache columns in
  // tenant_integrations + scrape_jobs so historical labels stay consistent.
  async updateCollection(collectionId, { name }) {
    const response = await api.patch(`/rag/collections/${collectionId}`, { name });
    return response.data;
  },

  // Documents
  async getDocuments(collectionId = 1) {
    try {
      const response = await api.get(`/rag/collections/${collectionId}/documents`);
      return response.data;
    } catch (error) {
      console.error('Error fetching documents:', error.response || error);
      throw error;
    }
  },

  async listAllDocuments() {
    const response = await api.get('/rag/documents');
    return response.data;
  },

  async uploadDocument(collectionId, file, options = {}) {
    const formData = new FormData();
    formData.append('file', file);
    
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    
    // Add abort signal if provided
    if (options.signal) {
      config.signal = options.signal;
    }
    
    // Add progress callback if provided
    if (options.onUploadProgress) {
      config.onUploadProgress = options.onUploadProgress;
    }
    
    const response = await api.post(
      `/rag/collections/${collectionId}/documents`,
      formData,
      config
    );
    return response.data;
  },

  async uploadMultipleDocuments(collectionId, files) {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    
    const response = await api.post(
      `/rag/collections/${collectionId}/documents/batch`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  },

  async uploadUrl(collectionId, url) {
    const formData = new FormData();
    formData.append('url', url);
    
    const response = await api.post(
      `/rag/collections/${collectionId}/documents/url`,
      formData
    );
    return response.data;
  },

  async deleteDocument(collectionId, documentName) {
    const response = await api.delete(
      `/rag/collections/${collectionId}/documents/${encodeURIComponent(documentName)}`
    );
    return response.data;
  },

  async deleteDocuments(collectionId) {
    const response = await api.delete(`/rag/collections/${collectionId}/documents`);
    return response.data;
  },

  // Search
  async searchDocuments(collectionId, query, k = 5) {
    const response = await api.post(`/rag/collections/${collectionId}/search`, {
      query,
      k
    });
    return response.data;
  },

  // Config
  async getSupportedTypes() {
    const response = await api.get('/rag/config/supported-types');
    return response.data;
  },

  async getSettings() {
    const response = await api.get('/rag/config/settings');
    return response.data;
  },

  // CRM Sync
  async syncCRMData(options) {
    const response = await api.post('/rag/sync/crm', options);
    return response.data;
  },

  // DMS Sync
  async syncDMSData(options) {
    const response = await api.post('/rag/sync/dms', options);
    return response.data;
  },

  // Get Sync Status
  async getSyncStatus(syncId) {
    const response = await api.get(`/rag/sync/status/${syncId}`);
    return response.data;
  },






  // Admin: Data Cleanup
  async getDataCleanupReport() {
    const response = await api.get('/rag/admin/data-cleanup');
    return response.data;
  },

  async deleteOrphanVectorCollection(collectionName) {
    const response = await api.delete(`/rag/admin/vector-collection/${encodeURIComponent(collectionName)}`);
    return response.data;
  },

  async deleteOrphanTenantCollection(collectionId) {
    const response = await api.delete(`/rag/admin/tenant-collection/${collectionId}`);
    return response.data;
  },

  async syncCollectionCounts() {
    const response = await api.post('/rag/admin/sync-counts');
    return response.data;
  },
};

export default ragService;